import { useMemo } from 'react'
import { filesApi } from '@papan/files/client'
import { useFileIO, driveFileIO } from '@papan/files/client/file-io'
import { createAppCodeContext } from './app-context.js'
import type { AppCodeContext } from './types.js'

/**
 * The app context for the file an editor has open — lazy: nothing is fetched
 * until a completion asks. Drive only: in a share view the drive API answers as
 * the link, not the person, so there the completions keep to the SDK / SQL /
 * Python vocabulary and offer no op files.
 */
export function useAppCodeContext(fileId: string | undefined): AppCodeContext | null {
  const io = useFileIO()
  const inDrive = io === driveFileIO
  return useMemo(() => (fileId && inDrive ? createAppCodeContext(fileId, filesApi) : null), [fileId, inDrive])
}
